"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@emotion/core");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _listing = _interopRequireDefault(require("../../models/listing"));
var _smallCard = _interopRequireDefault(require("../small-card"));
var styles = _interopRequireWildcard(require("./horizontal-slide.style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var HorizontalSlide = _ref => {
  var listings = _ref.listings,
    title = _ref.title,
    _onClick = _ref.onClick,
    noScroll = _ref.noScroll,
    Component = _ref.component;
  return (0, _core.jsx)("div", {
    css: /*#__PURE__*/(0, _core.css)([styles.horizontalSlide, !noScroll && styles.scroll])
  }, listings.map((listing, index) => (0, _core.jsx)(Component, {
    key: listing.url,
    title: title,
    listing: listing,
    onClick: () => {
      _onClick(listing, index);
    }
  })));
};
HorizontalSlide.propTypes = {
  listings: _propTypes.default.arrayOf(_propTypes.default.shape(_listing.default)),
  onClick: _propTypes.default.func,
  title: _propTypes.default.string,
  component: _propTypes.default.elementType,
  noScroll: _propTypes.default.bool
};
HorizontalSlide.defaultProps = {
  listings: [],
  onClick: () => {},
  title: 'Property of the Week',
  component: _smallCard.default,
  noScroll: false
};
var _default = exports.default = HorizontalSlide;